import React, { useState } from "react";
import classNames from "classnames";
import { FilterSourceItem, FilterValues } from "./FilterValuesCollection";
import productListAutocompleteService, { FilterKeyValuePair } from "./ProductListAutocompleteService";

interface ProductListPackageProducerFilterProperties {
    readonly isActive: boolean;
    readonly packageProducers: FilterSourceItem[];
    readonly filter: FilterValues;

    readonly onFilterChange: (filter: FilterValues) => void;
    readonly onActivateTab: () => void;
}

export default function ProductListPackageProducerFilter({
    isActive,
    packageProducers,
    filter,
    onFilterChange,
    onActivateTab,
}: ProductListPackageProducerFilterProperties): React.JSX.Element | undefined {
    const [autocompleteValue, setAutocompleteValue] = useState<string>("");
    const [currentPackageProducers, setCurrentPackageProducers] = useState<FilterKeyValuePair[]>(packageProducers
        .map((packageProducer) => ({
            id: packageProducer.id,
            title: packageProducer.title,
        })));

    if (packageProducers.length === 0) {
        return undefined;
    }

    const handleFilterToggle = (producerId: number): void => {
        let currentProducers: number[] = filter.Producers ?? [];

        if (currentProducers.includes(producerId)) {
            currentProducers = currentProducers.filter((id) => id !== producerId);
        } else {
            currentProducers.push(producerId);
        }

        onFilterChange(Object.assign({}, filter, { Producers: currentProducers }));
    };

    const handleAutocompleteInput = async (event: React.ChangeEvent<HTMLInputElement>): Promise<void> => {
        const value = event.target.value.toLowerCase();
        setAutocompleteValue(value);

        if (value.trim() === "") {
            setCurrentPackageProducers(packageProducers
                .map((packageProducer) => ({
                    id: packageProducer.id,
                    title: packageProducer.title,
                })));

            return;
        }

        if (value.trim().length < 2) {
            return;
        }

        setCurrentPackageProducers(await productListAutocompleteService.getPackageProducerFilterValues(value));
    };

    return (
        <div className="filter-widget filter-padding">
            <h2 className={isActive ? "active" : undefined} onClick={onActivateTab}>Značka<i className="fa-solid fa-caret-down"></i></h2>

            <div className={classNames("widget-content", { hidden: !isActive })}>
                <div className="widget-search">
                    <input
                        type="text"
                        placeholder="Zadejte hledanou značku"
                        onChange={(event) => void handleAutocompleteInput(event)}
                        value={autocompleteValue} />
                    <i className="fa-solid fa-search"></i>
                </div>

                <div className="widget-inner category-checkbox">
                    {currentPackageProducers.map((producer) => <div className="filter-container" key={producer.id}>
                        <label htmlFor={`fp_${producer.id}`}>
                            {producer.title}
                            <input
                                type="checkbox"
                                id={`fp_${producer.id}`}
                                value={producer.id}
                                onChange={() => handleFilterToggle(producer.id)}
                                checked={filter.Producers?.includes(producer.id)} />
                            <span className="checkmark"></span>
                            {producer.quantity !== undefined && <span> ({producer.quantity}&times;)</span>}
                        </label>
                    </div>)}
                </div>
                <div className="more-producers-note">Další značky zobrazíte vyhledáváním</div>
            </div>
        </div>
    );
}
